import Cookies from 'js-cookie';
const deserializeCookies = cookies => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const parsedCookies = {};
  Object.keys(cookies).forEach(c => {
    try {
      parsedCookies[c] = JSON.parse(cookies[c]);
    } catch (e) {
      // JSON.parse will throw if the cookie value is a string
      parsedCookies[c] = cookies[c];
    }
  });
  return parsedCookies;
};
function getAllCookies(initialCookies) {
  if (typeof window === 'undefined' && initialCookies) {
    return deserializeCookies(initialCookies);
  }
  return deserializeCookies(Cookies.get() || {});
}
export { getAllCookies as default, deserializeCookies };
//# sourceMappingURL=getAllCookies.js.map
